(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flossy-design"] && !Shopify.designMode) return;
  try {
    const flossyPanelSelector='.fx-menu, .fx-localization, .fl-region';
function closeFlossyPanel(panel,restoreFocus=false){
 panel.open=false;
 if(restoreFocus)panel.querySelector('summary')?.focus();
}
document.addEventListener('keydown',event=>{
 if(event.key!=='Escape')return;
 const panels=Array.from(document.querySelectorAll(flossyPanelSelector)).filter(panel=>panel.open);
 if(!panels.length)return;
 event.preventDefault();
 const focused=panels.find(panel=>panel.contains(document.activeElement))||panels[0];
 panels.forEach(panel=>closeFlossyPanel(panel,panel===focused));
});
document.addEventListener('click',event=>{
 const close=event.target.closest('[data-fl-panel-close]');
 if(close){
  const panel=close.closest(flossyPanelSelector);
  if(panel)closeFlossyPanel(panel,true);
 }
 document.querySelectorAll(flossyPanelSelector).forEach(panel=>{
  if(panel.open&&!panel.contains(event.target))closeFlossyPanel(panel);
 });
});
document.addEventListener('toggle',event=>{
 const panel=event.target;
 if(!panel.matches?.(flossyPanelSelector)||!panel.open)return;
 document.querySelectorAll(flossyPanelSelector).forEach(other=>{
  if(other!==panel&&other.open)closeFlossyPanel(other);
 });
},true);
document.addEventListener('focusin',event=>{
 document.querySelectorAll(flossyPanelSelector).forEach(panel=>{
  if(panel.open&&!panel.contains(event.target))closeFlossyPanel(panel);
 });
});
let flossyHeaderObserver;
function measureFlossyHeader(){
 const header=document.querySelector('.fx-header-section');
 if(!header)return;
 flossyHeaderObserver?.disconnect();
 const update=()=>document.documentElement.style.setProperty('--fl-navigation-height',header.getBoundingClientRect().height+'px');
 update();
 flossyHeaderObserver=new ResizeObserver(update);
 flossyHeaderObserver.observe(header);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',measureFlossyHeader);else measureFlossyHeader();
document.addEventListener('shopify:section:load',measureFlossyHeader);
matchMedia('(min-width:990px)').addEventListener('change',event=>{
 if(event.matches)document.querySelectorAll('.fx-menu[open]').forEach(panel=>closeFlossyPanel(panel));
});
let flossyStickyFrame;
function updateFlossySticky(){
  flossyStickyFrame=null;
  const bar=document.querySelector('.fx-sticky-buy');
  const button=document.querySelector('.product-form__submit');
  const footer=document.querySelector('.fx-footer');
  if(!bar||!button)return;
  const pastButton=button.getBoundingClientRect().bottom<0;
  const beforeFooter=!footer||footer.getBoundingClientRect().top>window.innerHeight+Math.max(bar.offsetHeight,96);
  const consent=Array.from(document.querySelectorAll('.shopify-pc__banner__dialog,.shopify-pc__prefs__dialog')).some(panel=>panel.getBoundingClientRect().height>0&&getComputedStyle(panel).visibility!=='hidden');
  const visible=pastButton&&beforeFooter&&!consent;
  if(bar.classList.contains('is-visible')!==visible)bar.classList.toggle('is-visible',visible);
}
function scheduleFlossySticky(){
  if(!flossyStickyFrame)flossyStickyFrame=requestAnimationFrame(updateFlossySticky);
}
window.addEventListener('scroll',scheduleFlossySticky,{passive:true});
window.addEventListener('resize',scheduleFlossySticky);
document.addEventListener('click',scheduleFlossySticky);
document.addEventListener('load',scheduleFlossySticky,true);
document.addEventListener('shopify:section:load',scheduleFlossySticky);
function initFlossySticky(){
  scheduleFlossySticky();
  if(document.querySelector('.fx-sticky-buy'))new MutationObserver(scheduleFlossySticky).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','open']});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFlossySticky);else initFlossySticky();
document.addEventListener('click',event=>{
  const link=event.target.closest('.fx-mobile-panel a');
  if(link)link.closest('details').open=false;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flossy-quantity-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flossy-quantity-choice')) {
  customElements.define('flossy-quantity-choice', class extends HTMLElement {
    connectedCallback() {
      this.input = document.getElementById(this.dataset.inputId);
      if (!this.input) return;
      this.buttons = Array.from(this.querySelectorAll('button[data-quantity]'));
      this.sync = () => {
        const min = Number(this.input.min || 1);
        const step = Number(this.input.step || 1);
        const parsedMax = Number(this.input.max);
        const ruleMax = this.input.max !== '' && Number.isFinite(parsedMax) ? parsedMax : Infinity;
        const stockMax = this.dataset.inventoryLimited === 'true' ? Number(this.dataset.inventory) - Number(this.input.dataset.cartQuantity || 0) : Infinity;
        const max = Math.min(ruleMax, stockMax);
        this.buttons.forEach(button => {
          const quantity = Number(button.dataset.quantity);
          button.disabled = quantity < min || quantity > max || (quantity - min) % step !== 0;
          button.setAttribute('aria-pressed', String(Number(this.input.value) === quantity));
        });
      };
      this.choose = event => {
        const button = event.target.closest('button[data-quantity]');
        if (!button || !this.contains(button)) return;
        this.sync();
        if (button.disabled) return;
        this.input.value = button.dataset.quantity;
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      };
      this.addEventListener('click', this.choose);
      this.input.addEventListener('input', this.sync);
      this.input.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.input, { attributes: true, attributeFilter: ['min', 'max', 'step', 'data-cart-quantity', 'value'] });
      this.sync();
      this.hidden = false;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.choose);
      this.input?.removeEventListener('input', this.sync);
      this.input?.removeEventListener('change', this.sync);
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flossy-ritual-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!document.body.classList.contains('flossy-site')) return;
  const selector = '.AirReviews-Blocks--ListItem[aria-label]';
  const cleanLabel = element => {
    if (!element.matches(selector)) return;
    const label = element.getAttribute('aria-label');
    const next = label.replace(/:\s*\d+\s+.*$/u, '');
    if (next !== label) element.setAttribute('aria-label', next);
  };
  const cleanTree = root => {
    if (!(root instanceof Element)) return;
    cleanLabel(root);
    root.querySelectorAll(selector).forEach(cleanLabel);
  };
  cleanTree(document.body);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') cleanLabel(record.target);
      else record.addedNodes.forEach(cleanTree);
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
})();
  } catch(e) { console.error(e); }
})();

})();
